export default "__VITE_PUBLIC_ASSET__0bd51c76__"